export enum HistoryActionTypeEnum {
    ADDED = '+',
    REMOVED = '-',
    UPDATED = '~',
}